import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const SettingsBlock = styled.div`
  border-bottom: 1px solid ${COLORS.secondaryLight};
  box-sizing: border-box;
`

export const Lists = styled.ul`
  position: relative;
  z-index: 5;
`
